import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-offer', 'dismissOffer', 'Отклонить предложение');
